export const reportType: Readonly<any> = {
    Pre: 'PreValidate',
    Post: 'PostValidate',
    PreCheck: 'PreCheck',
    default: 'Impact Analysis'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/reportType.ts